import type { FilterSectionConfig } from "@/shared/components/common/ListFilterPopover";
import { TENANT_USER_ACCOUNT_STATUS_OPTIONS } from "@/features/tenantUsers/constants";

/**
 * Students list filters: board, class and section are free-text inputs, status
 * is a dropdown (Active, Inactive, Pending, Marked for delete).
 */
export function getStudentsListFilterSections(
  t: (key: string) => string,
): FilterSectionConfig[] {
  return [
    {
      key: "board",
      label: t("students:filter.board"),
      options: [],
      type: "text",
      placeholder: t("students:filter.placeholder.board"),
    },
    {
      key: "class",
      label: t("students:filter.class"),
      options: [],
      type: "text",
      placeholder: t("students:filter.placeholder.class"),
    },
    {
      key: "section",
      label: t("students:filter.section"),
      options: [],
      type: "text",
      placeholder: t("students:filter.placeholder.section"),
    },
    {
      key: "accountStatus",
      label: t("students:filter.accountStatus"),
      options: [...TENANT_USER_ACCOUNT_STATUS_OPTIONS],
      type: "searchable-select",
      placeholder: t("students:filter.placeholder.status"),
    },
  ];
}